// extracted by mini-css-extract-plugin
export default {"error":"Question_error__jYVG2","isRequired":"Question_isRequired__YARf0"};